import React, { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SettingsDeleteButton } from './MeterConfiguration.style'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { DeleteMeterAction } from '../../../redux/meters/meter-actions'

export const DeleteMeterButton: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const meterId = useAppSelector((state: RootState) => state.meter.meterInEditor?.id)

  const deleteMeter = (): void => {
    if (meterId == null) {
      return
    }

    const confirmText: string = t('settings_dialog.delete_confirmation_long')
    if (!confirm(confirmText ?? 'Confirm meter deletion')) {
      return
    }

    dispatch(DeleteMeterAction({ meterId }))
  }

  return (
        <SettingsDeleteButton
            onClick={deleteMeter}
        >
            {t('settings_dialog.delete')}
        </SettingsDeleteButton>
  )
}
